import { dossierLoader, jobPageLoader, jobDetailLoader } from '../dossier/loaders';
import { DMS_COMMENTS_ROUTE, JOB_DETAIL_ROUTE, JOB_MASTER_ROUTE, JOB_PARENT_ROUTE } from '../general/router/constants';
import { allPermissions } from '../general/utils/authHelper';
import Permission from '../shared/constants/Permission';

const JobParentView = () => import('./views/JobParentView.vue');
const JobPage = () => import('./views/JobPage.vue');
const JobDetailView = () => import('./views/JobDetailView.vue');
const DmsCommentsView = () => import('./views/DmsCommentsView.vue');

export default [
  {
    path: '/dossier/:dossierId/jobs',
    name: JOB_PARENT_ROUTE,
    component: JobPage,
    props: {
      dossierContext: dossierLoader,
      context: jobPageLoader,
    },
    meta: {
      hasAccess: allPermissions(Permission.ACCESS_TO_DOSSIERS),
      title: 'jobs.title',
      showEmpty: true,
      logicalModule: 'dossier-detail',
    },
    children: [
      {
        path: '',
        name: JOB_MASTER_ROUTE,
        component: JobParentView,
        props: {
          context: jobPageLoader,
        },
      },
      {
        path: 'dms',
        name: DMS_COMMENTS_ROUTE,
        component: DmsCommentsView,
        props: {
          context: jobPageLoader,
        },
      },
      {
        path: ':jobId',
        name: JOB_DETAIL_ROUTE,
        component: JobDetailView,
        props: {
          context: jobDetailLoader,
        },
        meta: {
          showHeader: true,
        },
      },
    ],
  },
];
